import { render, staticRenderFns } from "./RegistrationWithLink.vue?vue&type=template&id=07e95fe0&"
import script from "./RegistrationWithLink.vue?vue&type=script&lang=js&"
export * from "./RegistrationWithLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports